/**
 * Fragment de routes du paquet v4-p05-sources-assistant (vague V4 ; règle R2 du découpage V4–V11 : un fragment par
 * paquet, `routes/v4.tsx` interdit), rendu par le registre v10. Composants chargés à la demande, aucun code exécuté au
 * chargement. Routes du socle remplacées (`remplace: true`), d'après le `couvre: route:` des YAML d'écrans :
 *  - `/projet/classement` → projet-classement (l'écran historique `ClassementProjet` n'est plus servi à cette adresse ;
 *    sa fiche `/projet/classement/:nature/:id` reste servie, projet-classement-fiche appartient à v4-p02) ;
 *  - `/compare` → projet-comparer-modeles (l'écran historique `ComparisonScreen` n'est plus servi).
 * Routes neuves (objet par l'adresse, `?projet=` transmis) :
 *  - `/projet/comparaisons/:comparaisonId` → projet-comparaison-fiche ;
 *  - `/projet/sources/:documentId` → projet-source-fiche.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProjetClassement = lazy(() => import('../ecrans/v4/sources/ProjetClassement'))
const ProjetComparerModeles = lazy(() => import('../ecrans/v4/sources/ProjetComparerModeles'))
const ProjetComparaisonFiche = lazy(() => import('../ecrans/v4/sources/ProjetComparaisonFiche'))
const ProjetSourceFiche = lazy(() => import('../ecrans/v4/sources/ProjetSourceFiche'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v4-sources',
  routes: [
    { chemin: '/projet/classement', element: ecran(ProjetClassement), remplace: true },
    { chemin: '/compare', element: ecran(ProjetComparerModeles), remplace: true },
    { chemin: '/projet/comparaisons/:comparaisonId', element: ecran(ProjetComparaisonFiche) },
    { chemin: '/projet/sources/:documentId', element: ecran(ProjetSourceFiche) },
  ],
}
